<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <app-business :contactPageData='contactPage'></app-business>
        <app-footer></app-footer>
    </div>
</template>


<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {listbusinessunits} from '../../config';
    import FrontFooter from '@/components/partials/FrontFooter';
    import EventBus from '../event-bus';
    import SessioMixin from '../../mixins/sessionmixin';
    import ListBusinessUnitsComponent from "@/components/businessUnit/ListBusinessUnitsComponent";

    export default {
        name: "businessunit",
        mixins: [SessioMixin],
        components: {
            'app-business': ListBusinessUnitsComponent,
            'app-footer': FrontFooter,
        },
        data: () => ({
                contactPage: {
                    pageTitle: 'Business Unit List',
                },
                isLoggedIn: false,
            }),
        beforeMount: function () {
            var self = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
            }
        },
        mounted: function () {
            var self = this;
            var userObj = localStorage.getItem('filters');
            
            $(".removeActive").removeClass('active');
            $("#menubusinessunits").addClass('active');
            // console.log(this.message);
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            self.showLoader();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        methods: {
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/businessUnit/ListBusinessUnits.vue